import axios, { axiosCleanInstance } from "./axios";
import { fromJson, toJson } from "./model/json";
import UserRest from "./model/UserRest";

const registerUser = (user: UserRest): Promise<UserRest> => {
  return axios
    .post("/api/users", { user: toJson(user) })
    .then((response) => fromJson(UserRest, response.data.user));
};

const updateUserData = ({
  privacyConsent,
  marketingConsent,
  firstName,
  lastName,
}: {
  privacyConsent?: boolean | undefined;
  marketingConsent?: boolean | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
}): Promise<UserRest> => {
  const updatePayload: {
    privacy_consent?: boolean;
    marketing_consent?: boolean;
    first_name?: string;
    last_name?: string;
  } = {};

  if (privacyConsent !== undefined) {
    updatePayload.privacy_consent = privacyConsent;
  }
  if (marketingConsent !== undefined) {
    updatePayload.marketing_consent = marketingConsent;
  }
  if (firstName) {
    updatePayload.first_name = firstName;
  }
  if (lastName) {
    updatePayload.last_name = lastName;
  }

  return axios.put("/api/users", updatePayload);
};

const registerUserV3 = (user: UserRest): Promise<UserRest> => {
  return axios
    .post("/api/v3/users", { user: toJson(user) })
    .then((response) => fromJson(UserRest, response.data.user));
};

const fetchLoggedUser = (): Promise<UserRest> => {
  return axiosCleanInstance
    .get("/api/users/me")
    .then((response) => fromJson(UserRest, response.data.user));
};

const usersApi = {
  fetchLoggedUser,
  registerUser,
  registerUserV3,
  updateUserData,
};

export default usersApi;
